export class FormatUtils {

    static pad(num: number, size: number, paddingChar: string): string {
        var s = num + "";
        while (s.length < size) s = paddingChar + s;
        return s;
    }

    static dateStringFromNgbDatepicker(datePickerModel: any): string {
        if (!datePickerModel) {
            return "";
        }
        return datePickerModel.year + "" + FormatUtils.pad(datePickerModel.month, 2, "0") + "" + FormatUtils.pad(datePickerModel.day, 2, "0");

    }

    static ngbDatepickerModelFromDateString(dateString: string): any {

        let year = parseInt(dateString.substring(0, 4));
        let month = parseInt(dateString.substring(5, 7));
        let day = parseInt(dateString.substring(8, 10));

        return { day: day, month: month, year: year };

    }

    static dateFormattedFromDateString(dateString: string): string {

        let year = parseInt(dateString.substring(0, 4));
        let month = parseInt(dateString.substring(5, 7));
        let day = parseInt(dateString.substring(8, 10));

        return FormatUtils.pad(day, 2, "0") + "/" + FormatUtils.pad(month, 2, "0") + "/" + FormatUtils.pad(year, 2, "0");

    }

    static dateHourFormattedFromDateString(dateString: string): string {

        let year = parseInt(dateString.substring(0, 4));
        let month = parseInt(dateString.substring(5, 7));
        let day = parseInt(dateString.substring(8, 10));
        let hour = parseInt(dateString.substring(11, 13));
        let minutes = parseInt(dateString.substring(14, 16));

        return FormatUtils.pad(day, 2, "0") + "/" + FormatUtils.pad(month, 2, "0") + "/" + FormatUtils.pad(year, 2, "0") + " " + FormatUtils.pad(hour, 2, "0") + ":" + FormatUtils.pad(minutes, 2, "0");

    }

    static hourArrayFromDatestring(datestring: string): any[] {

        let hour = parseInt(datestring.substring(8, 10));
        let minutes = parseInt(datestring.substring(11, 13));

        return [hour, minutes];

    }

    static dateFromDateString(dateString: string): Date {

        let year = parseInt(dateString.substring(0, 4));
        let month = parseInt(dateString.substring(5, 7));
        let day = parseInt(dateString.substring(8, 10));

        return new Date(year, (month - 1), day, 0, 0, 0, 0);

    }

    static dateITAFromDateString(dateString: string): Date {

        let year = parseInt(dateString.split("/")[2].trim());
        let month = parseInt(dateString.split("/")[1].trim());
        let day = parseInt(dateString.split("/")[0].trim());

        return new Date(year, (month - 1), day, 0, 0, 0, 0);

    }

    static foramtStringFromDateString(dateString: string): string {

        let ora = dateString.split("-")[0].trim();
        let data = dateString.split("-")[1].trim();

        return ora + " del " + data;

    }

    static dateHourFromDateString(dateString: string): Date {

        let year = parseInt(dateString.substring(0, 4));
        let month = parseInt(dateString.substring(5, 7));
        let day = parseInt(dateString.substring(8, 10));
        let hour = parseInt(dateString.substring(11, 13));
        let minutes = parseInt(dateString.substring(14, 16));

        return new Date(year, (month - 1), day, hour, minutes, 0, 0);

    }

    static dateHourITAFromDateString(dateString: string): Date {

        let year = parseInt(dateString.split("-")[0].split("/")[2].trim());
        let month = parseInt(dateString.split("-")[0].split("/")[1].trim());
        let day = parseInt(dateString.split("-")[0].split("/")[0].trim());
        let hour = parseInt(dateString.split("-")[1].split(":")[0].trim());
        let minutes = parseInt(dateString.split("-")[1].split(":")[1].trim());

        return new Date(year, (month - 1), day, hour, minutes, 0, 0);

    }

    static dateHourITAFromDateStringHHYY(dateString: string): Date {

        let year = parseInt(dateString.split("-")[1].split("/")[2].trim());
        let month = parseInt(dateString.split("-")[1].split("/")[1].trim());
        let day = parseInt(dateString.split("-")[1].split("/")[0].trim());
        let hour = parseInt(dateString.split("-")[0].split(":")[0].trim());
        let minutes = parseInt(dateString.split("-")[0].split(":")[1].trim());

        return new Date(year, (month - 1), day, hour, minutes, 0, 0);

    }

    static stringWithHourFromDate(date: Date): string {

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();

        return FormatUtils.pad(year, 4, "0") + "/" + FormatUtils.pad(month, 2, "0") + "/" + FormatUtils.pad(day, 2, "0") + FormatUtils.pad(hour, 2, "0") + ":" + FormatUtils.pad(minutes, 2, "0");

    }

    static stringWithHourFromDateWidthDel(date: Date): string {

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();

        return FormatUtils.pad(hour, 2, "0") + ":" + FormatUtils.pad(minutes, 2, "0") + " del " + FormatUtils.pad(day, 2, "0") + "/" + FormatUtils.pad(month, 2, "0") + "/" + FormatUtils.pad(year, 4, "0");

    }

    static stringFromDate(date: Date): string {

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        return FormatUtils.pad(year, 4, "0") + "-" + FormatUtils.pad(month, 2, "0") + "-" + FormatUtils.pad(day, 2, "0");

    }

    static stringFromDateIta(date: Date): string {

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        return FormatUtils.pad(day, 2, "0") + "/" + FormatUtils.pad(month, 2, "0") + "/" + FormatUtils.pad(year, 4, "0");

    }

    static stringWithScoreFromDateString(s: string): string {
        
        return s.split("/")[2]+"-"+s.split("/")[1]+"-"+s.split("/")[0];

    }

    static stringWithSlashFromDateString(s: string): string {
        
        return s.split("-")[2]+"/"+s.split("-")[1]+"/"+s.split("-")[0];

    }

    static ngbDatepickerModelFromDate(date: Date): any {

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        //console.log("Date " + date + " year " + year + " month " + month + " day " + day);

        return { day: day, month: month, year: year };

    }



    static stringFromTime(date: Date): string {

        let hour = date.getHours();
        let minutes = date.getMinutes();

        return FormatUtils.pad(hour, 2, "0") + ":" + FormatUtils.pad(minutes, 2, "0");

    }

}